import { toQueryString } from "../toQueryString";

const BASE_PATH = "/internal_api";
const normalizePath = (path: string) => path.replace(/^\/+/, "");

// Leading slashes in `path` are accepted — both absolutePath("foo") and
// absolutePath("/foo") produce the same result.
export const absolutePath = (
  path: string,
  params = {},
  queryStringOptions = {},
) =>
  `${BASE_PATH}/${normalizePath(path)}?${toQueryString(params, queryStringOptions)}`;

export const absolutePathWithArrayIndices = (
  path: string,
  params = {},
  queryStringOptions = {},
) =>
  `${BASE_PATH}/${normalizePath(path)}?${toQueryString(params, {
    ...queryStringOptions,
    arrayFormat: "indices",
  })}`;
